import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface HealthKeyFeaturesProps {
    healthCareData: any
}

const HealthKeyFeatures: FC<HealthKeyFeaturesProps> = ({ healthCareData }) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8 p-4 md:p-8 lg:p-20 lg:pt-16 lg:px-36 bg-blackDark'>
            {healthCareData.HealthCareFeatureList.map((reliable: any) => {
                return (
                    <motion.div className='rounded-3xl pb-[2px] pl-[2px]' style={{
                        backgroundImage: `linear-gradient(75.31deg, ${reliable.bgColor} 0%, rgba(132, 44, 255, 0) 19.33%)`,
                        borderImageSlice: 1,
                    }}
                        whileHover={{
                            scale: 1.02,
                            transition: { duration: 0.3 }
                        }}
                    >
                        <div className={`flex flex-col items-start justify-start p-4 md:p-6 lg:px-8 !rounded-3xl relative h-[100%]`}
                            style={{
                                background: `linear-gradient(145.33deg, ${reliable.bgColor}24, #1B1B1B 29.24%)`
                            }}
                        >
                            <div style={{
                                background: `linear-gradient(180deg, ${reliable.bgColor} 0%, rgba(152, 255, 18, 0) 77.08%)`,
                                borderImageSlice: 1,
                                borderImage: `linear-gradient(180deg, ${reliable.bgColor} 0%, rgba(152, 255, 18, 0) 77.08%)`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                WebkitTextStroke: "1.5px transparent",
                                WebkitTextStrokeColor: `${reliable.bgColor}10`,
                            }}
                                className={`text-4xl md:text-5xl lg:text-6xl font-extrabold bg-clip-text text-transparent`}>0{reliable.key}</div>
                            <div className='-mt-2 md:-mt-3 lg:-mt-4'>
                                <div className={`text-base md:text-lg lg:text-xl text-start font-semibold text-white mb-2 md:mb-3`}>
                                    {reliable.title}
                                </div>
                                <ul className='list-disc flex flex-col gap-2 md:gap-3 pl-4 md:pl-5'>
                                    {reliable.list.map((list: any) => {
                                        return (
                                            <li key={list.title}>
                                                <div className='text-white text-start text-sm md:text-base lg:text-md pr-2 md:pr-4 lg:pr-8 font-bold'>{list.title}</div>
                                                <div className='text-white text-start text-xs md:text-sm lg:text-base pr-2 md:pr-4 lg:pr-8'> {list.subtitle}</div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </motion.div>
                )
            })}
        </div>
    )
}

export default HealthKeyFeatures
